import { useState } from 'react'
import LoginModal from './LoginModal'
import LoginOTPModal from './LoginOTPModal'
import OTPConfirmModal from './OTPConfirmModal'

function LoginWebModal({ modalShowLoginPass, setModalShowLoginPass }) {
	function closeLoginModal() {
		setModalShowLoginPass(false)
	}
	function openAndCloseLoginSMSModal() {
		setModalShowLoginSMS(false)
		setModalShowLoginPass(true)
	}

	const [modalShowLoginSMS, setModalShowLoginSMS] = useState(false)
	function openLoginSMSModal() {
		setModalShowLoginPass(false)
		setModalShowLoginSMS(true)
	}
	function closeLoginSMSModal() {
		setModalShowLoginSMS(false)
	}

	const [modalShowOTP, setModalShowOTP] = useState(false)
	function openOTPAndCloseLoginSMSModal() {
		setModalShowLoginSMS(false)
		setModalShowOTP(true)
	}
	function closeOTPModal() {
		setModalShowOTP(false)
	}

	const [phone, setPhone] = useState('')

	return (
		<>
			{modalShowLoginPass && (
				<LoginModal
					show={modalShowLoginPass}
					onHide={closeLoginModal}
					onShowLoginSMS={openLoginSMSModal}
				/>
			)}
			{modalShowLoginSMS && (
				<LoginOTPModal
					show={modalShowLoginSMS}
					onHide={closeLoginSMSModal}
					onShowLogin={openAndCloseLoginSMSModal}
					onShowOTP={openOTPAndCloseLoginSMSModal}
					phone={phone}
					setPhone={setPhone}
				/>
			)}
			{modalShowOTP && (
				<OTPConfirmModal
					show={modalShowOTP}
					onHide={closeOTPModal}
					phone={phone}
				/>
			)}
		</>
	)
}

export default LoginWebModal
